'use es6';

import { Map as ImmutableMap } from 'immutable';
export const getDataKeys = (dataset, field) => dataset.get('data').map(r => r.get(field)).toOrderedSet().toList();
export const groupData = (data, [field, next, ...rest]) => {
  const grouped = data.groupBy(row => row.get(field));
  return next ? grouped.map(group => groupData(group, [next, ...rest])) : grouped;
};
export const mergeDefinedFields = (a = {}, b = {}) => ImmutableMap(a).filter(v => v !== undefined).merge(ImmutableMap(b).filter(v => v !== undefined));
export const applyOrder = (values, {
  defined
} = {}, pluck = identity => identity) => {
  if (!defined) {
    return values;
  }
  const orderLookup = ImmutableMap(defined.map((value, index) => [value, index]));
  return values.sortBy(value => orderLookup.get(pluck(value), orderLookup.count()));
};